import React, { forwardRef } from "react";
import { TextInput } from "../text-input";
import { TextInputProps } from "../text-input/types";
import { MaskedInput } from "../masked-input";
import { IMask } from "react-imask";
import { InputBaseComponentProps } from "@mui/material";

const MaskedInputFullDate = forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>(function MaskedInputFullDate(props, ref) {
  return (
    <GenericMaskedInputField
      {...props}
      ref={ref}
      mask="{day}.{month}.{year}"
      placeholder={"__.__.____"}
    />
  );
});

const MaskedInputPartialDate = forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>(function MaskedInputPartialDate(props, ref) {
  return (
    <GenericMaskedInputField
      {...props}
      ref={ref}
      mask="{month}.{year}"
      placeholder={"__.____"}
    />
  );
});

const GenericMaskedInputField = forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>((props, ref): React.JSX.Element => {
  const { value, className, ...rest } = props;

  let modifiedClassName = className;
  if (value && value !== "") {
    modifiedClassName += " scd-date-input-entered";
  }

  return (
    <MaskedInput
      {...rest}
      ref={ref}
      lazy={false}
      blocks={{
        day: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 31,
          maxLength: 2,
        },
        month: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
          maxLength: 2,
        },
        year: {
          mask: IMask.MaskedRange,
          from: 1900,
          to: 2099,
        },
      }}
      value={value}
      className={modifiedClassName}
    />
  );
});
GenericMaskedInputField.displayName = "GenericMaskedInputField";

export default function DatePicker({
  value,
  id,
  isFullDate = true,
  name,
  label,
  ...other
}: TextInputProps): React.JSX.Element {
  return (
    <div className="scd-date-input">
      <TextInput
        id={id}
        name={name}
        label={label}
        value={value}
        type="tel"
        endAdornment={<i className="icon-scd-calendar" />}
        CustomInputComponent={
          isFullDate ? MaskedInputFullDate : MaskedInputPartialDate
        }
        {...other}
      />
    </div>
  );
}
